import React, { useState } from "react";
import { fade, makeStyles } from '@material-ui/core/styles';
import "./LoginPage.css";
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import ResetPassword from "./components/ResetPassword";
import Loader from "../../components/Loader"
import MobileLogin from "./components/MobileLogin";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  loginContainer: {
    marginTop: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
    formInput: {
        marginTop: 10,
        marginBottom: 10,
    },
    image: {
      height: 120,
      marginBottom: theme.spacing(2),
    },
    inputGrid: {
      marginTop: theme.spacing(5)
    },
    inputLabel: {
      float: 'right'
    },
    forgotText: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(8)
    },
    registerText: {
      marginTop: theme.spacing(5)
    },
    resetButton: {
      textTransform: 'capitalize',
      color: '#3076CA'
    },
    loginButton: {
      textTransform: 'capitalize',
      background: '#3076CA',
      color: '#ffffff',
      "&:hover": {
        backgroundColor: fade('#3076CA', 0.75)
      }
    },
    singnUpInput: {
      float: 'left',
      backgroundColor: "#f5f5f5"
    },
    agreementText: {
      marginTop: theme.spacing(10),
      marginBottom: theme.spacing(5)
    },
    signUpInputGrid: {
      marginTop: theme.spacing(2)
    },
    resetSubmitButton: {
      marginTop: theme.spacing(7),
      textTransform: 'capitalize',
      background: '#3076CA',
      color: '#ffffff',
      "&:hover": {
        backgroundColor: fade('#3076CA', 0.75)
      }
    },
    sendConfirmBox : {
      backgroundColor: '#E6F6F5',
      padding: theme.spacing(2),
      borderRadius: 10
    }
  }));

export default function LoginPage(props) {
  const classes = useStyles();
  const { loginStep, appSettings } = props
  const [loading, setLoading] = useState(false);

  const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

  return (
    <div>
     {
        loading ? <Loader /> :
        <>
        {(() => {
          let comp = null;
          switch (loginStep) {
            case 'signUp':
              return (<SignUp classes={classes} lang={lang} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
              break;

            case 'initResetPassword':
              return (<ResetPassword classes={classes} lang={lang} isSend={false} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
              break;

            case 'initiateResetPassword':
              return (<ResetPassword classes={classes} lang={lang} isSend={true} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
              break;
        
            case 'login':
              return (<SignIn classes={classes} lang={lang} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
              break;
        
            case 'mobileLogin':
              return (<MobileLogin classes={classes} lang={lang} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
              break;
            
            default:
              return (<SignIn classes={classes} lang={lang} openSnackbar={props.openSnackbar} toggleLoader={(load) => setLoading(load)}  />)
          }
        })()}
        </>
      }
      
    </div>
  );
}